import React, { useState } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface FloatingTextareaProps {
  label: string;
  value?: string;
  onChange?: (value: string) => void;
  rows?: number;
  disabled?: boolean;
  dir?: "rtl" | "ltr";
  customClass?: string;
}

const FloatingTextarea: React.FC<FloatingTextareaProps> = ({
  label,
  value = "",
  onChange,
  rows = 4,
  disabled = false,
  dir = "rtl",
  customClass,
}) => {
  const [focused, setFocused] = useState(false);

  const isActive = focused || value.length > 0;

  return (
    <div className={classNames(styles.wrapper, customClass)} dir={dir}>
      <label className={`${styles.label} ${isActive ? styles.active : ""}`}>
        {label}
      </label>

      <div className={styles.scrollArea}>
        <textarea
          className={styles.textarea}
          value={value}
          rows={rows}
          disabled={disabled}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => onChange?.(e.target.value)}
        />
      </div>
    </div>
  );
};

export default FloatingTextarea;
